import React from "react";
import { Navigate } from "react-router-dom";

// Auth
import Login from "../pages/Authentication/Login";

import ChangePassword from "../pages/Authentication/ChangePassword";
import KitchenDashboard from "../pages/RMS/KitchenDisplay";
// import DashboardCrm from "../pages/DashboardCrm";

// 🔐 Auth protected routes
const authProtectedRoutes = [
  { path: "/dashboard", component: <KitchenDashboard /> },


  // Defaults → redirect to login instead of reservation
  { path: "/", component: <Navigate to="/login" /> },
  { path: "*", component: <Navigate to="/login" /> },
];

// 🌍 Public routes
const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/change-password", component: <ChangePassword /> },
];

export { authProtectedRoutes, publicRoutes };
